module.exports = __webpack_public_path__ + "img/andre.cda106a1.jpg";